export default function generateUUID() {
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const maxPos = chars.length
  let str = ''
  for (let i = 0; i < 12; i++) {
    str += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  let num = (new Date().getTime() % 1000).toString()
  if (num.length === 1) {
    num = '00' + num
  } else if (num.length === 2) {
    num = '0' + num
  }
  return str + num
}
